/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="104.77"
        height="95.58"
        viewBox="0 0 104.77 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M99.09 86.83a1.24 1.24 0 0 1 1.22 1.27 1.26 1.26 0 0 1-1.09 1.22H5.59a1.251 1.251 0 0 1-.12-2.5h93.62ZM103.46 93.09a1.24 1.24 0 0 1 1.31 1.18 1.25 1.25 0 0 1-1.18 1.32H1.23A1.27 1.27 0 0 1 0 94.31a1.25 1.25 0 0 1 1.1-1.21h102.36Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M57.7 18.99a5.36 5.36 0 1 0-5.37 5.35 5.36 5.36 0 0 0 5.35-5.35"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M52.35 12.38a6.61 6.61 0 1 0 6.63 6.61 6.6 6.6 0 0 0-6.63-6.61Zm0 2.5a4.11 4.11 0 1 1-4.11 4.11 4.11 4.11 0 0 1 4.11-4.11Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M51.59.25 4.95 37.48a1.24 1.24 0 0 0-.21 1.75 1.27 1.27 0 0 0 1 .48h93.37a1.25 1.25 0 0 0 1.25-1.25 1.24 1.24 0 0 0-.47-1L53.18.25a1.23 1.23 0 0 0-1.59 0Zm.78 2.58 43.12 34.33H9.29Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M77.45 30.93a1.24 1.24 0 0 1 1.22 1.27 1.26 1.26 0 0 1-1.09 1.22H27.52a1.27 1.27 0 0 1-1.32-1.19 1.25 1.25 0 0 1 1.19-1.31h50.06ZM23.38 42.05h-9a3 3 0 0 0 0 5.94h9a3 3 0 0 0 0-5.94Zm-9 2h9a1 1 0 0 1 .72 1.21 1 1 0 0 1-.72.73h-9a1 1 0 0 1-.73-1.22 1 1 0 0 1 .73-.72Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M15.18 45.99a1 1 0 0 1 1 .88v32.64a1.002 1.002 0 0 1-2 .12V46.99a1 1 0 0 1 1-1ZM22.59 45.99a1 1 0 0 1 1 .88v32.64a1 1 0 0 1-.94 1.06 1 1 0 0 1-1.06-.94V46.99a1 1 0 0 1 1-1ZM90.29 42.05h-9a3 3 0 0 0 0 5.94h9a3 3 0 0 0 0-5.94Zm-9 2h9a1 1 0 0 1 .72 1.21 1 1 0 0 1-.72.73h-9a1 1 0 0 1-.73-1.22 1 1 0 0 1 .73-.72Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M82.09 45.99a1 1 0 0 1 1 .88v32.64a1 1 0 0 1-.94 1.06 1 1 0 0 1-1.06-.94V46.99a1 1 0 0 1 1-1ZM89.52 45.99a1 1 0 0 1 1 .88v32.64a1 1 0 0 1-.94 1.06 1 1 0 0 1-1.06-.94V46.99a1 1 0 0 1 1-1ZM68.04 42.05h-9a3 3 0 0 0 0 5.94h9a3 3 0 0 0 0-5.94Zm-9 2h9a1 1 0 0 1 .72 1.21 1 1 0 0 1-.72.73h-9a1 1 0 0 1-.73-1.22 1 1 0 0 1 .73-.72Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M59.84 45.99a1 1 0 0 1 1 .88v32.64a1 1 0 0 1-.94 1.06 1 1 0 0 1-1.06-.94V46.99a1 1 0 0 1 1-1ZM67.27 45.99a1 1 0 0 1 1 .88v32.64a1 1 0 0 1-.94 1.06 1 1 0 0 1-1.06-.94V46.99a1 1 0 0 1 1-1ZM45.71 42.05h-9a3 3 0 1 0 0 5.94h9a3 3 0 0 0 0-5.94Zm-9 2h9a1 1 0 0 1 .72 1.21 1 1 0 0 1-.72.73h-9a1 1 0 0 1-1.22-.73 1 1 0 0 1 .73-1.21 1 1 0 0 1 .49 0ZM23.38 78.51h-9a3 3 0 0 0 0 5.94h9a3 3 0 0 0 0-5.94Zm-9 2h9a1 1 0 0 1 .72 1.21 1 1 0 0 1-.72.73h-9a1 1 0 0 1-.73-1.22 1 1 0 0 1 .73-.72ZM90.29 78.51h-9a3 3 0 0 0 0 5.94h9a3 3 0 0 0 0-5.94Zm-9 2h9a1 1 0 0 1 .72 1.21 1 1 0 0 1-.72.73h-9a1 1 0 0 1-.7-1.2 1 1 0 0 1 .7-.74Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M68.04 78.51h-9a3 3 0 0 0 0 5.94h9a3 3 0 0 0 0-5.94Zm-9 2h9a1 1 0 0 1 .72 1.21 1 1 0 0 1-.72.73h-9a1 1 0 0 1-.73-1.22 1 1 0 0 1 .73-.72ZM45.71 78.51h-9a3 3 0 1 0 0 5.94h9a3 3 0 0 0 0-5.94Zm-9 2h9a1 1 0 0 1 .72 1.21 1 1 0 0 1-.72.73h-9a1 1 0 0 1-1.22-.73 1 1 0 0 1 .73-1.21 1 1 0 0 1 .49 0Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M37.51 45.99a1 1 0 0 1 1 .88v32.64a1.002 1.002 0 0 1-2 .12V46.99a1 1 0 0 1 1-1ZM44.98 45.99a1 1 0 0 1 1 .88v32.64a1 1 0 0 1-.94 1.06 1 1 0 0 1-1.06-.94V46.99a1 1 0 0 1 1-1Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'FourRomanColumnsYellowRoofDotIcon';

export default Icon;
